import { dismissAlert, showError } from '@calendly/alert'
import { useFormContext } from '@calendly/form'
import { useOnValueChange } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { useDispatch } from 'react-redux'

import { useHasFormErrors } from './hooks'

export const ValidationErrorAlert = () => {
  const dispatch = useDispatch()
  const hasErrors = useHasFormErrors()
  const { submitCount } = useFormContext()

  useOnValueChange(submitCount, () => {
    if (hasErrors) {
      dispatch(showError(I18n.t('publisher.event_type_editor.sections.errors.section')))
    }
  })

  useOnValueChange(hasErrors, () => {
    if (!hasErrors) {
      dispatch(dismissAlert())
    }
  })

  return null
}
